import { filteredEntityIdAbout, filteredEntityIdConversations, supportedStaticTabScopeInHarmony, } from '../constants';
/** Some tabs can now go through without contentUrl as part of re-ordering tabs.
 * This function filters out tabs we can't use or which are invalid.
 */
export const filterStaticTabs = (staticTabs) => staticTabs.filter((_) => {
    var _a;
    return _.contentUrl &&
        _.entityId !== filteredEntityIdAbout &&
        _.entityId !== filteredEntityIdConversations &&
        ((_a = _.scopes) === null || _a === void 0 ? void 0 : _a.includes(supportedStaticTabScopeInHarmony));
});
//# sourceMappingURL=filterStaticTabs.js.map